'use strict';
import {EwSiteApp} from '../../app/ewsiteapp.js';

EwSiteApp.controller('CalendarWeekMonthCtrl', ['$scope', '$http', '$filter', '$log', '$location', function ($scope, $http, $filter, $log, $location) {
    $scope.show_calendar_tab = true;
    $scope.show_upcoming_events = true;
    $scope.show_day_events = false;
    $scope.show_filtered_list = false;
    $scope.active_tab_calendar = true;
    $scope.show_week_tab = false;
    $scope.active_tab_week = false;
    $scope.show_month_tab = false;
    $scope.active_tab_month = false;
    $scope.upcoming_events = [];
    $scope.list_events = [];
    $scope.show_list_tab = false;
    $scope.active_tab_list = false;
    $scope.is_search = false;
    $scope.isDateSelectedByUser = false;
    $scope.day_events = [];
    $scope.selected_y = '';
    $scope.selected_m = '';
    $scope.selected_d = '';
    $scope.selected_date = '';
    $scope.list = [];
    $scope.monthly = {};
    $scope.weekly = {};
    $scope.calendarId = '';
    $scope.events_url = '';
    $scope.more_url = $scope.events_url;
    $scope.date = '';
    $scope.days = [];

    //calendar events pagination START
    $scope.currentPageCalendar = 1;
    $scope.currentPageDayEvents = 1;
    $scope.currentPageUpcoming = 1;
    $scope.currentPageMonthly = 1;
    $scope.currentPageWeekly = 1;
    $scope.currentPageListEvents = 1;

    $scope.monthNames = {
        "January": "Sausio",
        "February": "Vasario",
        "March": "Kovo",
        "April": "Balandžio",
        "May": "Gegužės",
        "June": "Birželio",
        "July": "Liepos",
        "August": "Rugpjūtčio",
        "September": "Rugsėjo",
        "October": "Spalio",
        "November": "Lapkričio",
        "December": "Gruodžio"
    };

    $scope.getTranslatedMonth = function(timestamp) {
        const month = new Date(timestamp * 1000).toLocaleString('en-US', { month: 'long' });
        return $scope.monthNames[month] || month;
    };

    function setPagingData(page, eventsList, pageSize = 8) {
        $scope.totalItems = eventsList.length;
        var pagedData = eventsList.slice(
            (page - 1) * pageSize,
            page * pageSize
        );
        return pagedData;
    }

    $scope.isOneDayEvent = function(event) {
        if (!event.date || !event.date_to) return false;

        const startDate = new Date(event.date * 1000);
        const endDate = new Date(event.date_to * 1000);

        return (
            startDate.getFullYear() === endDate.getFullYear() &&
            startDate.getMonth() === endDate.getMonth() &&
            startDate.getDate() === endDate.getDate()
        );
    };

    function resetCurrentPages() {
        $scope.currentPageCalendar = $scope.currentPageDayEvents = $scope.currentPageUpcoming = $scope.currentPageMonthly = $scope.currentPageWeekly = $scope.currentPageListEvents = 1;
    }

    $scope.$watch("day_events", function () {
        if ($scope.day_events != undefined) {
            $scope.pagedDayEvents = setPagingData($scope.currentPageDayEvents, $scope.day_events, 8);
        }
    });

    $scope.$watch("currentPageDayEvents", function () {
        $scope.pagedDayEvents = setPagingData($scope.currentPageDayEvents, $scope.day_events, 8);
    });

    $scope.$watch("calendar", function () {
        if ($scope.calendar != undefined) {
            $scope.pagedCalendarEvents = setPagingData($scope.currentPageCalendar, $scope.calendar.list);
        }
    });

    $scope.$watch("currentPageCalendar", function () {
        if ($scope.calendar != undefined) {
            $scope.pagedCalendarEvents = setPagingData($scope.currentPageCalendar, $scope.calendar.list);
        }
    });

    $scope.$watch("upcoming_events", function () {
        if ($scope.upcoming_events != undefined) {
            $scope.pagedUpcoming = setPagingData($scope.currentPageUpcoming, $scope.upcoming_events, 8);
        }
    });

    $scope.$watch("currentPageUpcoming", function () {
        $scope.pagedUpcoming = setPagingData($scope.currentPageUpcoming, $scope.upcoming_events, 8);
    });

    $scope.$watch("list_events", function () {
        if ($scope.list_events != undefined) {
            $scope.pagedListEvents = setPagingData($scope.currentPageListEvents, $scope.list_events, 16);
        }
    });

    $scope.$watch("currentPageListEvents", function () {
        $scope.pagedListEvents = setPagingData($scope.currentPageListEvents, $scope.list_events, 16);
    });

    $scope.$watch("monthly", function () {
        if ($scope.monthly?.list != undefined) {
            $scope.pagedMonthly = setPagingData($scope.currentPageMonthly, $scope.monthly.list);
        }
    });

    $scope.$watch("currentPageMonthly", function () {
        if ($scope.monthly?.list != undefined) {
            $scope.pagedMonthly = setPagingData($scope.currentPageMonthly, $scope.monthly.list);
        }
    });

    $scope.$watch("weekly", function () {
        if ($scope.weekly?.list != undefined) {
            $scope.pagedWeekly = setPagingData($scope.currentPageWeekly, $scope.weekly.list);
        }
    });

    $scope.$watch("currentPageWeekly", function () {
        if ($scope.weekly?.list != undefined) {
            $scope.pagedWeekly = setPagingData($scope.currentPageWeekly, $scope.weekly.list);
        }
    });
    //calendar events pagination END

    $scope.$watch("calendarId", function(newValue) {
        if(typeof(newValue) !== 'undefined'){
            $scope.calendar = eventscalendarData[newValue].calendar;
            $scope.weekly = eventscalendarData[newValue].weekly;
            $scope.monthly = eventscalendarData[newValue].monthly;
            $scope.upcoming_events = eventscalendarData[newValue].upcoming_events;
            $scope.perpage = eventscalendarData[newValue].perpage;
            $scope.prev_url = eventscalendarData[newValue].calendar.headers.prev_url;
            $scope.base_url = eventscalendarData[newValue].calendar.headers.base_url;
            $scope.next_url = eventscalendarData[newValue].calendar.headers.next_url;
            $scope.reset_url = eventscalendarData[newValue].calendar.headers.reset_url;
            $scope.list_events = eventscalendarData[newValue].list_events;
            $scope.list_url = eventscalendarData[newValue].list_url;
            $scope.days = eventscalendarData[newValue].calendar.days;

            if($scope.date) {
                let searchDate = $scope.date.replaceAll('-', '');
                let selectedDate;

                for(const day of $scope.days) {
                    let date = day[searchDate];

                    if(date) {
                        selectedDate = date;
                        break;
                    }
                }

                if(selectedDate) {
                    $scope.selectDate(selectedDate);
                }
            }
        }
    });

    $scope.$watch("events_url", function(newValue) {
        if(typeof(newValue) !== 'undefined'){
            $scope.events_url = newValue;
            $scope.more_url = $scope.events_url;
        }
    });

    $scope.selectNearestUpcomingEvent = function () {
        let currentDate = new Date();
        let upcomingEvents = [];
        for (const day of $scope.day_events) {
            for (let dateKey in day) {
                let eventDate = new Date(dateKey.slice(0, 4), dateKey.slice(4, 6) - 1, dateKey.slice(6, 8));

                if (eventDate >= currentDate && day[dateKey].items_count > 0) {
                    upcomingEvents.push(day[dateKey]);
                }

                if (upcomingEvents.length === 3) {
                    break;
                }
            }
            if (upcomingEvents.length === 3) {
                break;
            }
        }

        if (upcomingEvents.length > 0) {
            $scope.upcoming_events = upcomingEvents;
            $scope.selectDate(upcomingEvents[0]);
        } else {
            $scope.resetToInitialState();
        }

        $scope.isDateSelectedByUser = false;
    };

    $scope.resetToInitialState = function () {
        Object.assign($scope, $scope.initialState);

        $scope.show_calendar_tab = true;
        $scope.show_upcoming_events = true;
        $scope.show_day_events = false;
        $scope.show_filtered_list = false;
        $scope.active_tab_calendar = true;

        $scope.loadData('reset');
    };

    $scope.show_spinner = false;

    $scope.getDefaultParams = function () {
        return {
            category_id: '',
            location_id: '',
            years: '',
            title: '',
            date: '',
            date_to: ''
        };
    };
    $scope.filter_params = $scope.getDefaultParams();
    $scope.url_params = $scope.getDefaultParams();

    $scope.filterParams = function () {
        if ($filter('json')($scope.filter_params) !== $filter('json')($scope.getDefaultParams())) {
            $scope.url_params = angular.copy($scope.filter_params);
        }
        $scope.loadData();
    };

    $scope.resetUrlParams = function () {
        $scope.filter_params = $scope.getDefaultParams();
        $scope.url_params = $scope.getDefaultParams();
        $scope.show_filtered_list = false;
        $scope.loadData('reset');
    };

    $scope.hideCalendarTab = function () {
        $scope.show_calendar_tab = false;
        $scope.active_tab_calendar = false;
        $scope.show_upcoming_events = false;
        $scope.show_day_events = false;
    };

    $scope.showWeekTab = function () {
        if ((event && (event.type == 'click' || event.keyCode == 13)) || !event) {
            $scope.show_week_tab = true;
            $scope.active_tab_week = true;
            $scope.prev_url = $scope.weekly.headers.prev_url;
            $scope.base_url = $scope.weekly.headers.base_url;
            $scope.next_url = $scope.weekly.headers.next_url;
            $scope.hideCalendarTab();
            $scope.hideMonthTab();
            $scope.hideListTab();
        }
    };

    $scope.hideWeekTab = function () {
        $scope.show_week_tab = false;
        $scope.active_tab_week = false;
    };

    $scope.showMonthTab = function () {
        if ((event && (event.type == 'click' || event.keyCode == 13)) || !event) {
            $scope.show_month_tab = true;
            $scope.active_tab_month = true;
            $scope.prev_url = $scope.monthly.headers.prev_url;
            $scope.base_url = $scope.monthly.headers.base_url;
            $scope.next_url = $scope.monthly.headers.next_url;
            $scope.hideCalendarTab();
            $scope.hideWeekTab();
            $scope.hideListTab();
        }
    };

    $scope.hideMonthTab = function () {
        $scope.show_month_tab = false;
        $scope.active_tab_month = false;
    };

    $scope.showListTab = function (event) {
        if ((event && (event.type == 'click' || event.keyCode == 13)) || !event) {
            $scope.show_list_tab = true;
            $scope.active_tab_list = true;
            $scope.prev_url = $scope.monthly.headers.prev_url;
            $scope.base_url = $scope.monthly.headers.base_url;
            $scope.next_url = $scope.monthly.headers.next_url;
            $scope.hideCalendarTab();
            $scope.hideWeekTab();
            $scope.hideMonthTab();
        }
    };

    $scope.hideListTab = function () {
        $scope.show_list_tab = false;
        $scope.active_tab_list = false;
    };

    $scope.getPrevWeek = function () {
        if (event.type == 'click' || event.keyCode == 13) {
            $scope.loadData('prev');
            $scope.currentPageWeekly = 1;
        }
    };

    $scope.getNextWeek = function () {
        if (event.type == 'click' || event.keyCode == 13) {
            $scope.loadData('next');
            $scope.currentPageWeekly = 1;
        }
    };

    $scope.setCategoryFilter = function (/*checkbox*/) {
        $scope.show_day_events = false;
        $scope.show_upcoming_events = false;

        if ($scope.url_params.category_id == '') {
            $scope.show_filtered_list = false;
        } else {
            $scope.show_filtered_list = true;
        }
        resetCurrentPages();
    };

    $scope.setLocationFilter = function () {
        $scope.show_day_events = false;
        $scope.show_upcoming_events = false;
        $scope.filterParams();
        if ($scope.url_params.location_id == '') {
            $scope.show_filtered_list = false;
        } else {
            $scope.show_filtered_list = true;
        }
        resetCurrentPages();
    };

    $scope.setYearsFilter = function () {
        $scope.show_day_events = false;
        $scope.show_upcoming_events = false;
        $scope.filterParams();
        if ($scope.url_params.years == '') {
            $scope.show_filtered_list = false;
        } else {
            $scope.show_filtered_list = true;
        }
        resetCurrentPages();
    };

    $scope.$watch('url_params.years', function (newVal, oldVal) {
        if (typeof (oldVal) !== 'undefined' && oldVal !== '' && newVal == '') {
            $('#years_select').val('').trigger('change.select2');
        }
    }, true);

    $scope.disabledSearchBtn = function () {
        if ($scope.show_list_tab && ($scope.url_params.title == '' && $scope.url_params.category_id == '' && $scope.url_params.location_id == '' && $scope.url_params.date == '' && $scope.url_params.date_to == '')) {
            return true;
        }
        return false;
    };

    $scope.getPrevMonth = function (event) {
        if (event.type == 'click' || event.keyCode == 13) {
            $scope.loadData('prev');
            $scope.currentPageMonthly = 1;
        }
    };

    $scope.getNextMonth = function (event) {
        if (event.type == 'click' || event.keyCode == 13) {
            $scope.loadData('next');
            $scope.currentPageMonthly = 1;
        }
    };

    $scope.reInitCalendarUrls = function () {
        if ($scope.calendar && $scope.calendar.headers) {
            $scope.prev_url = $scope.calendar.headers.prev_url;
            $scope.base_url = $scope.calendar.headers.base_url;
            $scope.next_url = $scope.calendar.headers.next_url;
            $scope.reset_url = $scope.calendar.headers.reset_url;
        }
    };

    $scope.reInitMonthlyUrls = function () {
        if ($scope.monthly && $scope.monthly.headers) {
            $scope.prev_url = $scope.monthly.headers.prev_url;
            $scope.base_url = $scope.monthly.headers.base_url;
            $scope.next_url = $scope.monthly.headers.next_url;
        }
    };

    $scope.reInitWeeklyUrls = function () {
        if ($scope.weekly && $scope.weekly.headers) {
            $scope.prev_url = $scope.weekly.headers.prev_url;
            $scope.base_url = $scope.weekly.headers.base_url;
            $scope.next_url = $scope.weekly.headers.next_url;
        }
    };

    $scope.loadData = function (week_direction) {
        let url = $scope.base_url;

        if (typeof week_direction !== 'undefined' && week_direction !== '') {
            if (week_direction === 'next') {
                url = $scope.next_url;
            } else if (week_direction === 'reset') {
                url = $scope.reset_url;
            } else if (week_direction === 'prev') {
                url = $scope.prev_url;
            }
        }

        if (url !== '') {
            $scope.show_spinner = true;

            $http({
                method: 'GET',
                url: url,
                params: {
                    category_id: $scope.url_params.category_id,
                    location_id: $scope.url_params.location_id,
                    years: $scope.url_params.years,
                },
            }).then(function (response) {
                if (response.data && response.data.success) {
                    $scope.show_spinner = false;

                    if ($scope.active_tab_calendar) {
                        $scope.calendar = response.data[$scope.calendarId].calendar;
                        $scope.upcoming_events = response.data[$scope.calendarId].upcoming_events;

                        $scope.reInitCalendarUrls();
                    } else if ($scope.active_tab_week) {
                        $scope.weekly = response.data.weekly;
                        $scope.reInitWeeklyUrls();
                    } else if ($scope.active_tab_month) {
                        $scope.monthly = response.data.monthly;
                        $scope.reInitMonthlyUrls();
                    }
                } else {
                    $log.error(response.data.message);
                }
            });
        }
    };


    $scope.showDayEvents = function (day, event) {
        if (event.type === 'click' || event.keyCode === 13) {
            $scope.selectDate(day);

            const selectedEvent = day.events[0];
            if (selectedEvent) {
                const eventUrl = $scope.more_url + `&event_id=${selectedEvent.id}`;
                $location.url(eventUrl);
            }
        }
    };

    $scope.selectDate = function (day) {
        $scope.selected_y = day.y;
        $scope.selected_m = day.m;
        $scope.selected_month_title = day.month_title_k;
        $scope.selected_d = day.d;
        $scope.selected_date = day.y + '-' + day.m.padStart(2, '0') + '-' + day.d.padStart(2, '0');
        $scope.show_upcoming_events = false;
        $scope.show_filtered_list = false;
        $scope.show_day_events = true;
        $scope.day_events = day.events;
        $scope.currentPageDayEvents = 1;
        $scope.more_url = $scope.events_url + '?date=' + $scope.selected_date;

        if (event && (event.type === 'click' || event.type === 'keydown' && event.keyCode === 13)) {
            $scope.isDateSelectedByUser = true;
        } else {
            $scope.isDateSelectedByUser = false;
        }
    };

    $scope.searchEvents = function () {
        var url = $scope.list_url;
        if (url !== '') {
            $scope.show_spinner = true;
            $http({
                method: 'GET',
                url: url,
                params: {
                    category_id: $scope.url_params.category_id,
                    location_id: $scope.url_params.location_id,
                    title: $scope.url_params.title,
                    date: $scope.url_params.date,
                    date_to: $scope.url_params.date_to,
                }
            }).then(function (response) {
                if (!angular.isUndefined(response.data)) {
                    if (response.data.success) {
                        $scope.show_spinner = false;
                        $scope.is_search = true;
                        $scope.list_events = response.data.list_events;
                    } else {
                        $log.error(response.data.message);
                    }
                }
                if (!angular.isUndefined(response.data.debug)) {
                    $log.debug(response.data.debug);
                }
            });
        }
    };
    $scope.clearSearchEvents = function () {
        $scope.is_search = false;
        $scope.url_params = $scope.getDefaultParams();
        $('#category_select').val('').trigger('change.select2');
        $('#location_select').val('').trigger('change.select2');
        var url = $scope.list_url;
        if (url !== '') {
            $scope.show_spinner = true;
            $http({
                method: 'GET',
                url: url,
                params: {
                    category_id: '',
                    location_id: '',
                    title: '',
                    date: '',
                    date_to: '',
                }
            }).then(function (response) {
                if (!angular.isUndefined(response.data)) {
                    if (response.data.success) {
                        $scope.show_spinner = false;
                        $scope.list_events = response.data.list_events;
                    } else {
                        $log.error(response.data.message);
                    }
                }
                if (!angular.isUndefined(response.data.debug)) {
                    $log.debug(response.data.debug);
                }
            });
        }
    };


}]).directive('calendarContainer', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            element[0].dataset.place == 'module' ? scope.itemsPerPage = 8 : scope.itemsPerPage = 4;
            scope.calendarId = '';
            scope.events_url = '';
            if (attr.calendarId !== '') {
                scope.calendarId = attr.calendarId;
            }
            if (attr.eventsUrl !== '') {
                scope.events_url = attr.eventsUrl;
            }
            if (attr.calendarDate !== '') {
                scope.date = attr.calendarDate;
            }
        }
    };
});